import type { FieldGroup } from './types.js';

export const residence: FieldGroup = {
  key: 'residence',
  label: 'Residence & Address',
  step: 11,
  description: 'Current, permanent, native, and ancestral addresses.',
  fields: [
    {
      order: 1,
      key: 'currentAddress',
      label: 'Current Address',
      type: 'address',
      step: 11,
      isOnboarding: true,
      description: 'State → District → Village / Colony',
    },
    {
      order: 2,
      key: 'permanentAddress',
      label: 'Permanent Address',
      type: 'address',
      step: 11,
      isOnboarding: true,
      optional: true,
    },
    {
      order: 3,
      key: 'homeNativePlace',
      label: 'Home Native Place',
      type: 'address',
      step: 11,
      isOnboarding: true,
      optional: true,
    },
    {
      order: 4,
      key: 'ancestralPlace',
      label: 'Ancestral Place',
      type: 'address',
      step: 11,
      isOnboarding: true,
      optional: true,
    },
  ],
};
